require("./bootstrap");
require("./main");
require("./header");
require("./header-2023");
require("./progress");
require("../../node_modules/@splidejs/splide/dist/js/splide.js");
require("./gallery");
require("./mousemove");
require("./burger");
require("../../node_modules/bootstrap/js/src/collapse")

window.Modal = require("../../node_modules/bootstrap/js/dist/modal");

window.HomeScript = require("./home-script");
